export enum AdminCompanySection {
  General = 'general',
  Users = 'users',
  Billing = 'billing',
}
